var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreasuryRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6666 7.99992C14.6666 11.6818 11.6818 14.6666 7.99992 14.6666C4.31802 14.6666 1.33325 11.6818 1.33325 7.99992C1.33325 4.31802 4.31802 1.33325 7.99992 1.33325C11.6818 1.33325 14.6666 4.31802 14.6666 7.99992ZM11.2704 12.2131C10.3672 12.9152 9.2324 13.3333 7.99992 13.3333C5.0544 13.3333 2.66659 10.9454 2.66659 7.99992C2.66659 6.76743 3.08465 5.63259 3.7867 4.72947L11.2704 12.2131ZM12.2132 11.2703L4.72951 3.78666C5.63263 3.08463 6.76746 2.66659 7.99992 2.66659C10.9454 2.66659 13.3333 5.0544 13.3333 7.99992C13.3333 9.23238 12.9152 10.3672 12.2132 11.2703Z",
    fill: "#6B92FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreasuryRejected);
export default __webpack_public_path__ + "static/media/treasury-rejected.3b7ed723.svg";
export { ForwardRef as ReactComponent };